import { useGetSlotPageQuery } from "../api/controllers/slot"
import { useAppSelector } from "../store/hooks"
import { selectCurrentProjectId } from "../store/projects/selectors"

export const useSlots = (queryProjectId?: string) => {
    const currentProjectId = useAppSelector(selectCurrentProjectId)
    const projectId = queryProjectId || currentProjectId || ""
    const getSlotPageQuery = useGetSlotPageQuery({ projectId }, { skip: !projectId })

    return getSlotPageQuery.data?.Items ?? []
}
